import ScrollOut from "scroll-out";
import Rellax from "rellax";

var settore = $('.settore');
var settoreImgWrapper = $(".settore__imageWrapper");

settoreImgWrapper.each(function(index, element) {
    element == this;
    var rellax = new Rellax(element, {
        speed: 1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
    });
});

ScrollOut({
    targets: '.settore',
    threshold: 0.2,
    onShown(el) {
        el.classList.add('animated', 'fadeInUp');
    }
});